import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { Checkbox } from '../../UIComponents';

function CheckboxCatalogItem(props) {
  const {
    onClick, hasAccess, isSelected, disabled = false,
  } = props;

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    onClick(event);
  };

  return (
    <div
      className="catalogItem__checkbox"
      style={{ zIndex: !hasAccess ? 7 : null }}
      role="checkbox"
      aria-checked={isSelected}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : '0'}
      onClick={handleClick}
      onKeyPress={handleClick}
    >
      {/* <span /> */}
      <Checkbox
        value={isSelected}
        onChange={() => {}}
      />
    </div>
  );
}

CheckboxCatalogItem.propTypes = {
  hasAccess: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default memo(CheckboxCatalogItem);
